module.exports = __webpack_public_path__ + "static/img/15fd712aa475cbc52960cfd03197edd.c9ec023.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/15fd712aa475cbc52960cfd03197edd.jpg
// module id = nEuX
// module chunks = 1